"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

exports.__esModule = true;
exports.testProviderE2E = exports.testTE = exports.testNormalized = void 0;

var convert_1 = require("@shootismoke/convert");

var pipeable_1 = require("fp-ts/lib/pipeable");

var T = __importStar(require("fp-ts/lib/Task"));

var TE = __importStar(require("fp-ts/lib/TaskEither"));

function generateRandomLatLng() {
  return {
    latitude: Math.floor(Math.random() * 9000) / 100,
    longitude: Math.floor(Math.random() * 9000) / 100
  };
}

function generateRandomStationId() {
  return "" + (Math.floor(Math.random() * 1000) + 1);
}
/**
 * Test that normalized data is correct
 *
 * @param normalized - The normalized data to test
 */


function testNormalized(normalized) {
  normalized.forEach(function (data) {
    expect(data.country.length).toBe(2);
    expect(data.date).toBeDefined();
    expect(data.location).toHaveProperty('latitude');
    expect(data.location).toHaveProperty('longitude');
    expect(convert_1.AllPollutants.includes(data.parameter)).toBe(true);
    expect(data.value).toBeDefined();
    expect(data.unit).toBeDefined();
  });
}

exports.testNormalized = testNormalized;
/**
 * Test that a TE is resolving correctly.
 */

function testTE(te, normalize, done) {
  pipeable_1.pipe(te, TE.map(function (response) {
    expect(response).toBeDefined();
    return response;
  }), TE.chain(function (response) {
    return TE.fromEither(normalize(response));
  }), TE.fold(function (error) {
    // We don't fail the test if one of the following errors occur
    var skippedErrorMessages = [// Skip if the random stationId is an unknown station
    'Unknown ID', // Skip if we somehow couldn't connect
    'can not connect', // Skip if openaq doesn't return results
    '[openaq] Cannot normalize, got 0 result', // Skip if aqicn doesn't track pollutants that don't interest us
    'no pollutants currently tracked', // Skip if aqicn doesn't expose city
    'no city', // Skip if cannot find country for waqi
    '[waqi] Cannot get code from country'];

    if (skippedErrorMessages.some(function (msg) {
      return error.message.includes(msg);
    })) {
      done();
      return T.of(void undefined);
    }

    done.fail(error);
    return T.of(void undefined);
  }, function () {
    done();
    return T.of(void undefined);
  }))()["catch"](console.error);
}

exports.testTE = testTE;
/**
 * Test helper to test a provider
 */

function testProviderE2E(provider, _a) {
  var options = _a.options,
      _b = _a.skip,
      skip = _b === void 0 ? [] : _b;

  if (!skip.includes('fetchByGps')) {
    describe('fetchByGps', function () {
      __spread(Array(2)).map(generateRandomLatLng).forEach(function (gps) {
        it("should fetch " + provider.id + " by gps: " + JSON.stringify(gps), function (done) {
          return testTE(provider.fetchByGps(gps, options), function (d) {
            return provider.normalizeByGps(d);
          }, done);
        });
      });
    });
  }

  if (!skip.includes('fetchByStation')) {
    describe('fetchByStation', function () {
      __spread(Array(2)).map(generateRandomStationId).forEach(function (stationId) {
        it("should fetch " + provider.id + " by station: " + stationId, function (done) {
          return testTE(provider.fetchByStation(stationId, options), function (d) {
            return provider.normalizeByStation(d);
          }, done);
        });
      });
    });
  }
}

exports.testProviderE2E = testProviderE2E;